import React, { useEffect } from 'react';
import { Form, Row, Col } from 'antd';
import Copy from '@/components/copy';
import { enhancedFormateTimeStamp } from '@/common/utils/format-time';
import { goto } from '@/common/utils';
import env from '@/env';
import utils from '@/common/utils';
import { Link } from 'react-router-dom';

const AddChannelDetailInfo = (props) => {
  const { towerInfo } = props;

  return (
    // <div style={{ paddingBottom: '64px' }}>
    // <Form layout="vertical">
    <Row gutter={80}>
      <Col span={8}>
        <Form.Item label="通天塔项目标题:">
          <div>{towerInfo.towerName}</div>
        </Form.Item>
      </Col>
      <Col span={8}>
        <Form.Item label="通天塔项目ID:">
          <Copy text={towerInfo.towerId} size="small" />
        </Form.Item>
      </Col>
      <Col span={8}>
        <Form.Item label="页面有效时间:">
          <div>
            {utils.formateTimeStamp(towerInfo.towerBeginTime, true)} ~
            {utils.formateTimeStamp(towerInfo.towerEndTime, true)}
          </div>
        </Form.Item>
      </Col>
      <Col span={8}>
        <Form.Item label="页面主标题:">
          <div>{towerInfo.mainTitle}</div>
        </Form.Item>
      </Col>
      <Col span={8}>
        <Form.Item label="页面副标题:">
          <div>{towerInfo.lessTitle}</div>
        </Form.Item>
      </Col>
      <Col span={8}>
        <Form.Item label="品类:">
          <div>{towerInfo.category}</div>
        </Form.Item>
      </Col>
      <Col span={8}>
        <Form.Item label="页面运营语:">
          <Copy text={towerInfo.pageTag} size="small" />
        </Form.Item>
      </Col>
      <Col span={8}>
        <Form.Item label="页面选品规则:">
          <Link
            to={towerInfo.ruleId && `/batch-micro#/integration/manage?ruleId=${towerInfo.ruleId}`}
            target="_blank"
            rel="noopener"
          >
            查看规则
          </Link>
        </Form.Item>
      </Col>
    </Row>
    // </Form>
    // </div>
  );
};

export default AddChannelDetailInfo;
